export default __webpack_public_path__ + "static/media/landing-2.bfdd37b1.png";